<div class="fixed-footer">
  <div class="m-1">
    <div class="row text-center justify-content-between align-items-center">
      <div class="col-xs-12  col-sm-12 col-md-12  col-lg-12 mt-1">
        KenIndia Travel Insurance @ 2024-2025 Version 1.0
      </div>

    </div>
  </div>
</div>